import axios from 'axios';
import config from '../../config/app';

const groupBy = (array, property) => {
  const groupedResult = {};
  array.forEach((element) => {
    if (element[property] in groupedResult) {
      groupedResult[element[property]].push(element);
    } else {
      groupedResult[element[property]] = [element];
    }
  });
  return groupedResult;
};

const mapKeys = (object, keyMutator) => {
  const mutatedObject = {};
  Object.keys(object).forEach((key) => {
    const mutatedKey = keyMutator(object[key], key);
    mutatedObject[mutatedKey] = object[key];
  });
  return mutatedObject;
};

const map = (object, mapFunction) => {
  const mapResult = [];
  Object.keys(object).forEach((key) => {
    mapResult.push(mapFunction(object[key], key));
  });
  return mapResult;
};

export const getDefaultContactMethods = (contactMethods) => {
  let contacts = groupBy(contactMethods, 'type');
  contacts = mapKeys(contacts, (_value, key) => key.split('_contact_method').join(''));
  contacts = map(contacts, (methods, type) => ({ type, method: methods[0] }));
  return contacts;
};

export const contactExists = (contacts, contactType, contactData) => {
  const contactIndex = contacts.findIndex((contact) => {
    const { type, address, countryCode } = contact;
    const typeMatches = type === `${contactType}_contact_method`;
    const addressMatches = address === contactData.address;
    const countryCodeMatches = countryCode === contactData.countryCode;

    return typeMatches && addressMatches && countryCodeMatches;
  });

  return contactIndex >= 0;
};

export const generateContactPayload = (contact, type) => {
  const payload = {};
  payload.address = contact.address;
  if (['phone', 'sms'].includes(type)) {
    payload.country_code = contact.countryCode;
  }
  payload.label = 'Other';
  payload.type = `${type}_contact_method`;
  return { contact_method: payload };
};

export const getContactMethods = user => axios({
  method: 'GET',
  baseURL: config.BASE_PATH,
  url: `/api/v1/users/${user.id}/contact_methods`,
  headers: { 'X-PagerDuty-Api-Local': 1 }
});

export const postContactMethod = (user, contactData) => axios({
  method: 'POST',
  baseURL: '/api/v1/',
  url: `/users/${user.id}/contact_methods`,
  headers: { 'X-PagerDuty-Api-Local': 1 },
  data: contactData
});

export const postNotificationForContact = (user, contactData) => axios({
  method: 'POST',
  baseURL: '/api/v1/',
  url: `/users/${user.id}/contact_methods`,
  headers: { 'X-PagerDuty-Api-Local': 1 },
  data: contactData
});
